import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { ToastComponent } from "../../../../../shared/components/toast/toast.component";
import { AdminTopbarComponent } from "../../../components/admin-topbar/admin-topbar.component";
import { AdminNavigationComponent } from "../../../components/admin-navigation/admin-navigation.component";
import { CustomButtonComponent } from "../../../../../shared/components/custom-button/custom-button.component";
import { SalesEngineDataService } from '../../../../../core/services/sales-engine-data.service';
import { SalesEngineService } from '../../../../../core/api/sales-engine.service';
import { ApiErrorService } from '../../../../../core/api/api-error.service';
import { DeleteConfirmationDialogComponent } from '../../../../../shared/dialogs/delete-confirmation-dialog/delete-confirmation-dialog.component';
import { OpportunityGet } from '../../../../../core/interfaces/sales-engine-interfaces';
import { lastValueFrom } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { CreateEditOpportunityComponent } from "../../../components/upsell-engine/create-edit-opportunity/create-edit-opportunity.component";

@Component({
  selector: 'app-admin-opportunities',
  standalone: true,
  imports: [TranslocoPipe, ToastComponent, AdminTopbarComponent, AdminNavigationComponent, CustomButtonComponent, DeleteConfirmationDialogComponent, CommonModule, CreateEditOpportunityComponent],
  templateUrl: './admin-opportunities.component.html',
  styleUrl: './admin-opportunities.component.css'
})
export class AdminOpportunitiesComponent implements OnInit {
  constructor(private salesEngineData: SalesEngineDataService, private salesEngine: SalesEngineService, private apiError: ApiErrorService, private cdRef: ChangeDetectorRef) { }

  @ViewChild(ToastComponent) toast?: ToastComponent;

  @ViewChild(DeleteConfirmationDialogComponent) deleteDialog!: DeleteConfirmationDialogComponent;
  @ViewChild('editCreateRef') editCreateRef!: ElementRef;

  isEditCreateOpen: boolean = false;
  isEditing: boolean = false;
  selectedOpportunity?: OpportunityGet;

  get opportunities(): Array<OpportunityGet> {
    return this.salesEngineData.getOpportunities();
  }

  reloadOpportunities = () => this.salesEngineData.reloadOpportunities();

  ngOnInit(): void {
    this.cdRef.detectChanges();
  }

  createOpportunity() {
    if (this.isEditCreateOpen) {
      this.isEditCreateOpen = false;
      this.cdRef.detectChanges();
    }

    this.isEditCreateOpen = true;
    this.cdRef.detectChanges();



    this.isEditing = false;
    this.selectedOpportunity = undefined;

    this.editCreateRef.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
  }

  editOpportuniry(item: OpportunityGet) {
    if (this.isEditCreateOpen) {
      this.isEditCreateOpen = false;
      this.cdRef.detectChanges();
    }

    this.isEditCreateOpen = true;
    this.cdRef.detectChanges();

    this.isEditing = true;
    this.selectedOpportunity = item;

    this.editCreateRef.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
  }

  async deleteOpportunity(item: OpportunityGet) {
    if (!await this.deleteDialog.openModal()) {
      return;
    }

    try {
      await lastValueFrom(this.salesEngine.deleteOpportunity(item.id));

      this.reloadOpportunities();
    } catch (error) {
      var crid = 'UNKNOWN-CRID';
      if (error instanceof HttpErrorResponse) {
        crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
      }
      this.toast?.showToast(await this.apiError.getErrorHeader(), await this.apiError.getErrorMessage(crid), 'error', 8000, false);
      return;
    }
  }
}
